var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AbstractModule } from '@g.frame/core';
import { Loader, LoaderEventsName } from '@g.frame/common.loaders';
import { Object3D, Quaternion, Vector3 } from 'three';
import { OculusQuestModule } from '@g.frame/oculus.quest';
import { Tablet } from './instruments/Tablet';
import { QuestHandViewModule } from "../../hands_view/src/QuestHandViewModule";
import { XRControllerModelEvents } from "@g.frame/common.xr_manager";
export class InstrumentsPackModule extends AbstractModule {
    constructor() {
        super();
        this.container = new Object3D();
    }
    preInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // console.info('Module pre initialization.. Just make sure, that module is supported.');
            return {
                enabled: true
            };
        });
    }
    onInit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.tablet = new Tablet(data.viewer.camera.parent);
            return [];
        });
    }
    afterInit(agents, modules) {
        const loader = agents.get(Loader);
        this.tablet.loadResources(loader);
        loader.on(LoaderEventsName.loaded, () => {
            this.tablet.prepareResources(loader);
        });
        this.container.add(this.tablet.uiObject);
        this.tablet.uiObject.position.set(-0.5, 1, 0);
        const oculusQuestModule = modules.get(OculusQuestModule);
        const oculusQuestHand = modules.get(QuestHandViewModule);
        if (oculusQuestModule && oculusQuestModule.oculusQuestModel) {
            const model = oculusQuestModule.oculusQuestModel;
            model.on(XRControllerModelEvents.controllerChanged, (event) => {
                if (oculusQuestHand.questHandView.rayRight)
                    oculusQuestHand.questHandView.rayRight.visible = true;
                let handData = event.data[this.tablet.hand];
                if ((handData === null || handData === void 0 ? void 0 : handData.squeeze.pressed) || this.tablet.stickToHand) {
                    const globalPosition = new Vector3();
                    this.tablet.uiObject.getWorldPosition(globalPosition);
                    const controllerPosition = handData.pose.position.clone().applyMatrix4(this.tablet.cameraParent.matrixWorld);
                    if (globalPosition.distanceTo(controllerPosition) < 0.05 || this.tablet.stickToHand) {
                        this.tablet.uiObject.position.copy(this.tablet.uiObject.parent.worldToLocal(controllerPosition));
                        const cameraParentWorldOrientation = new Quaternion();
                        this.tablet.cameraParent.getWorldQuaternion(cameraParentWorldOrientation);
                        this.tablet.uiObject.quaternion.copy(cameraParentWorldOrientation.clone().multiply(handData.pose.orientation.clone()));
                        this.tablet.action(handData.trigger.value);
                    }
                }
            });
            this.tablet.setOculusModel(oculusQuestModule.oculusQuestModel);
        }
    }
    onUpdate(params) {
        // console.info('Module on update function. Use it to update instances.');
    }
    onDestroy() {
        // console.info('Module destroy function. Use it to destroy and dispose instances.');
    }
    onResume() {
    }
    onPause() {
    }
    getModuleContainer() {
        return this.container;
    }
}
